export default __webpack_public_path__ + "static/media/A-Standard.03b1032d.png";